import { Icon, Typography } from "@mui/material";
import React from "react";

const SummaryCardComponent = (props) => {
  const { icon, title, value, colorObj } = props;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: "0",
          width: "50px",
          height: "50px",
          borderRadius: "6px",
          marginBottom: "16px",
          backgroundColor: colorObj.bgColor,
        }}
      >
        <Icon
          style={{
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentcolor",
            flexShrink: "0",
            transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
            fontSize: "1.5rem",
            color: colorObj.mainColor,
          }}
        >
          {icon}
        </Icon>
      </div>

      <Typography
        variant="p"
        style={{
          fontWeight: 600,
          fontSize: "15px",
          lineHeight: 1.65,
          color: "rgb(95, 116, 141)",
          marginBottom: "8px",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h2"
        style={{
          fontSize: "26px",
          fontWeight: "600",
          color: colorObj.mainColor,
          lineHeight: "1",
        }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default SummaryCardComponent;
